import { APPLICATION_JSON } from "@/constans";
import { handleResponse } from "@/services/handlers";
import {
  BACKEND_BASE_URL,
  IResponseError,
  OrdersService,
  IOrdersService,
  SolCustomerCurrencyService,
  ISolCustomerCurrencyService,
  IEmployeesService,
  EmployeesService,
} from "@/services";
import Vue from "vue";
import {
  ISolCustomerService,
  ISolCustomerEmployeeParams,
  ISolCustomerEmployeeResponse,
  ISolCustomerImageParams,
  ISolCustomerImageResponse,
  ISolCustomerVehicleParams,
  ISolCustomerVehicleResponse,
} from "@/services/backend/sol_customer/sol_customer.types";

export class SolCustomerService implements ISolCustomerService {
  orders: IOrdersService | undefined;
  currency: ISolCustomerCurrencyService | undefined;
  employees: IEmployeesService | undefined;

  constructor() {
    this.orders = new OrdersService();
    this.currency = new SolCustomerCurrencyService();
    this.employees = new EmployeesService();
  }

  async getEmployee(
    params: ISolCustomerEmployeeParams
  ): Promise<ISolCustomerEmployeeResponse | undefined> {
    const headers: Record<string, unknown> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      Promise<ISolCustomerEmployeeResponse | undefined>,
      IResponseError
    >(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol-customer/${params.countryCode}/v2/employee`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getImage(params: ISolCustomerImageParams): Promise<ISolCustomerImageResponse | undefined> {
    const headers: Record<string, unknown> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      Promise<ISolCustomerImageResponse | undefined>,
      IResponseError
    >(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol-customer/${params.country}/v1/getImage`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getVehicle(
    params: ISolCustomerVehicleParams
  ): Promise<ISolCustomerVehicleResponse | undefined> {
    const headers: Record<string, unknown> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      Promise<ISolCustomerVehicleResponse | undefined>,
      IResponseError
    >(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol-customer/${params.countryCode}/v1/vehicle`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
